import './claim-entity.detail.notes.scss';

import { Box } from '@mui/material';
import { ClaimEntityPageContainer } from './claim-entity.page.container';
import { NewConvergeButton } from '../../../presentation';
import { useClaimQuery } from '@converge/graphql';
import { useConvergeSnackBar } from '../../../contexts';

export const ClaimDocumentDetailNote = () => {
  const extractClaimUuidFromUrl = (
    url: string = window.location.pathname
  ): string => {
    const match = url.match(/\/claims\/([^/]+)/);
    return match ? match[1] : '';
  };
  const claimUuid = extractClaimUuidFromUrl();

  const { data: claimData, loading: documentsLinkLoading } = useClaimQuery({
    claimUuid,
  });
  const { notify } = useConvergeSnackBar();

  const handleDocumentClick = () => {
    if (claimData?.claims?.edges[0]?.node?.documentLink) {
      window.open(claimData.claims.edges[0].node.documentLink, '_blank');
    } else {
      notify('There is no document folder', { variant: 'error' });
    }
  };

  return (
    <Box
      sx={{
        overflow: 'hidden',
        height: '100vh',
        position: 'fixed',
        width: '100%',
      }}
    >
      <ClaimEntityPageContainer
        title={'Documents'}
        titleChildren={
          <Box style={{ backgroundColor: 'white' }}>
            <>
              <Box>Access all of the documents associated with this claim.</Box>
            </>
          </Box>
        }
      >
        <Box style={{ marginLeft: '25px', marginTop: '40px', width: '170px' }}>
          <NewConvergeButton
            onClick={handleDocumentClick}
            data-cy="claim-documents-button"
            label={'VIEW DOCUMENTS'}
            loading={documentsLinkLoading}
          />
        </Box>
      </ClaimEntityPageContainer>
    </Box>
  );
};
